import { ActionTypes } from '../Constants';
import AppInfo from '../model/AppInfo';
import HostInfo from '../model/HostInfo';
import User from '../model/User';
import SosdbRoleAction from '../model/SosdbRoleAction';
import KioskVersionSet from '../model/KioskVersionSet';
import KioskVersionSetHistory from '../model/KioskVersionSetHistory';
import LoginAttempt from '../model/LoginAttempt';
import LogURL from '../model/LogURL';
import Storage from '../Storage';
import Api from '../Api';
import Util from '../Util';
import SosdbG2ConvertHistory from '../model/SosdbG2ConvertHistory';
import _ from 'lodash';
import Org2OrgConvertHistory from '../model/Org2OrgConvertHistory';

export function getSosdbRoleActionList() {
  return (dispatch) => {
    return Api.getSosdbRoleActionList().then((data) => {
      let roleActionList = data || [];
      roleActionList = roleActionList.map((roleAction) => {
        return new SosdbRoleAction(roleAction);
      });
      dispatch({
        type: ActionTypes.ADD_ROLE_ACTION_LIST,
        roleActionList: roleActionList,
      });
      return roleActionList;
    });
  };
}

export function createSosdbRoleAction(roleAction) {
  return (dispatch) => {
    return Api.createSosdbRoleAction(roleAction).then((data) => {
      let createdRoleAction = new SosdbRoleAction(data);
      dispatch({
        type: ActionTypes.ADD_ROLE_ACTION,
        roleAction: createdRoleAction,
      });
      return createdRoleAction;
    });
  };
}

export function updateSosdbRoleAction(roleAction) {
  return (dispatch) => {
    return Api.updateSosdbRoleAction(roleAction).then((data) => {
      let updatedRoleAction = new SosdbRoleAction(data);
      dispatch({
        type: ActionTypes.ADD_ROLE_ACTION,
        roleAction: updatedRoleAction,
      });
      return updatedRoleAction;
    });
  };
}

export function deleteSosdbRoleAction(roleAction) {
  return (dispatch) => {
    return Api.deleteSosdbRoleAction(roleAction).then((data) => {
      let deletedRoleAction = new SosdbRoleAction(data);
      dispatch({
        type: ActionTypes.DELETE_ROLE_ACTION,
        roleAction: deletedRoleAction,
      });
      return data;
    });
  };
}

export function getUserList() {
  return (dispatch) => {
    return Api.getUserList().then((data) => {
      let userList = data || [];
      userList = userList.map((user) => {
        return new User(user);
      });
      dispatch({
        type: ActionTypes.ADD_USER_LIST,
        userList: userList,
      });
      return userList;
    });
  };
}

export function createUser(user) {
  return (dispatch) => {
    return Api.createUser(user).then((data) => {
      let createdUser = new User(data);
      dispatch({
        type: ActionTypes.ADD_USER,
        user: createdUser,
      });
      return createdUser;
    });
  };
}

export function updateUser(user) {
  return (dispatch) => {
    return Api.updateUser(user).then((data) => {
      let updatedUser = new User(data);
      dispatch({
        type: ActionTypes.ADD_USER,
        user: updatedUser,
      });
      return updatedUser;
    });
  };
}

export function updateProfile(user) {
  return (dispatch) => {
    return Api.updateProfile(user).then((data) => {
      let updatedUser = new User(data);
      Storage.setProfile(updatedUser);
      dispatch({
        type: ActionTypes.ADD_USER,
        user: updatedUser,
      });
      dispatch({
        type: ActionTypes.UPDATE_PROFILE,
        user: updatedUser,
      });
      return updatedUser;
    });
  };
}

export function deleteUserByEmail(email) {
  return (dispatch) => {
    return Api.deleteUserByEmail(email).then((data) => {
      dispatch({
        type: ActionTypes.DELETE_USER,
        email: email,
      });
      return data;
    });
  };
}

export function getLoginAttemptList(success = false, limit = 300) {
  return (dispatch) => {
    return Api.getLoginAttemptList(success, limit).then((data) => {
      let loginAttemptList = data || [];
      loginAttemptList = loginAttemptList.map((attempt) => {
        return new LoginAttempt(attempt);
      });
      dispatch({
        type: ActionTypes.ADD_LOGIN_ATTEMPT_LIST,
        loginAttemptList: loginAttemptList,
      });
      return loginAttemptList;
    });
  };
}

let lastGetHostInfoListAt = new Date(1970, 0, 1);

// guard against fetching host info multiple times within 10 seconds
export function getHostInfoList(showLoadingStatus = false, force = false) {
  let shouldGetHostInfoList = (new Date() - lastGetHostInfoListAt) > (10 * 1000);
  if (force) {
    shouldGetHostInfoList = true;
  }

  __DEBUG__ && console.log(
    'lastGetHostInfoListAt: ' + lastGetHostInfoListAt.toLocaleString(),
    'shouldGetLastInfoList: ' + shouldGetHostInfoList,
    'showLoadingStatus: ' + showLoadingStatus,
    'force: ' + force
  );

  if (shouldGetHostInfoList) {
    lastGetHostInfoListAt = new Date();
    return _getHostInfoList(showLoadingStatus);
  }

  return () => {
    return new Promise(() => {});
  };
}

function _getHostInfoList(showLoadingStatus = false) {
  return (dispatch, getState) => {
    let state = getState();
    console.log('hostInfoListStatus.isLoading', state.hostInfoListStatus.isLoading);

    if (Storage.isProfileCommissionRole() || state.hostInfoListStatus.isLoading) {
      return new Promise(() => {});
    }

    // only set the hostInfoListStatus.isLoading for first time after logging in
    if (showLoadingStatus) dispatch({ type: ActionTypes.START_GETTING_HOST_INFO_LIST });

    return Api.getHostInfoList()
      .then(async (data) => {
        let hostInfoList = data || [];

        __DEBUG__ && console.log(
            Util.localDateTimeString(new Date()),
            'getHostInfoList: the host info list',
            hostInfoList.length
          );

        let kvsList = await dispatch(getKVSList());

        hostInfoList = hostInfoList.map((hostInfo) => {
          hostInfo = new HostInfo(hostInfo);
          if (kvsList && kvsList.length > 0) {
            hostInfo.calculateKvsNames(kvsList);
          }
          return hostInfo;
        });

        dispatch({
          type: ActionTypes.ADD_HOST_INFO_LIST,
          hostInfoList,
        });
        dispatch({
          type: ActionTypes.FINISH_GETTING_HOST_INFO_LIST,
        });
        return hostInfoList;
      })
      .catch((err) => {
        dispatch({
          type: ActionTypes.ERROR_GETTING_HOST_INFO_LIST,
          errorMessage: err.message,
        });
        throw err;
      });
  };
}

export function getHostInfo(id) {
  return (dispatch) => {
    return Api.getHostInfo(id).then((data) => {
      let hostInfo = new HostInfo(data);
      dispatch({
        type: ActionTypes.ADD_HOST_INFO,
        hostInfo: hostInfo,
      });
      return hostInfo;
    });
  };
}

export function deleteHostInfo(id) {
  return (dispatch) => {
    return Api.deleteHostInfo(id).then((data) => {
      dispatch({
        type: ActionTypes.DELETE_HOST_INFO,
        id,
      });
      return data;
    });
  };
}

export function updateHostInfo(hostInfo) {
  return (dispatch) => {
    return Promise.resolve(() => {
      let newHostInfo = new HostInfo(hostInfo);
      dispatch({
        type: ActionTypes.ADD_HOST_INFO,
        hostInfo: newHostInfo,
      });
      return hostInfo;
    });
  };
}

export function fetchInfo(hostInfo) {
  return (dispatch) => {
    return Api.fetchInfo(hostInfo).then((data) => {
      let newHostInfo = new HostInfo(data);
      dispatch({
        type: ActionTypes.ADD_HOST_INFO,
        hostInfo: newHostInfo,
      });
      return newHostInfo;
    });
  };
}

export function fetchInfoByIP(ipaddr, authType, fingerprint) {
  return (dispatch) => {
    return Api.fetchInfoByIP(ipaddr, authType, fingerprint).then((data) => {
      let hostInfo = new HostInfo(data);
      dispatch({
        type: ActionTypes.ADD_HOST_INFO,
        hostInfo: hostInfo,
      });
      return hostInfo;
    });
  };
}

// Based on:
// * https://auth0.com/blog/secure-your-react-and-redux-app-with-jwt-authentication/
export function loginUserWithPassword(email, password) {
  return (dispatch) => {
    return Api.login(email, password)
      .then((user) => {
        Storage.clearSheldonFileCache();

        dispatch(getHostInfoList(true));

        dispatch({
          type: ActionTypes.LOGIN_SUCCESS,
          user: user,
        });
        return user;
      })
      .catch((err) => {
        dispatch({
          type: ActionTypes.LOGIN_FAILURE,
          errorMessage: err.message,
        });
        throw err;
      });
  };
}

export function loginAndRenewToken() {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.LOGIN_SUCCESS,
      user: Storage.getProfile(),
    });

    return Api.renewToken();
  };
}

export function logoutUser() {
  return (dispatch) => {
    Storage.clearTokenAndSessionData();

    dispatch({
      type: ActionTypes.LOGOUT_SUCCESS,
    });

    return Promise.resolve();
  };
}

export function getKVSList() {
  return (dispatch) => {
    return Api.getKVSList().then((data) => {
      let kvsList = data || [];
      kvsList = kvsList.map((kvs) => {
        return new KioskVersionSet(kvs);
      });
      dispatch({
        type: ActionTypes.ADD_KVS_LIST,
        kvsList: kvsList,
      });
      _fetchKVSHistoryList(dispatch);
      return kvsList;
    });
  };
}

function _fetchKVSHistoryList(dispatch) {
  return Api.getKVSHistoryList(0, 300).then((data) => {
    let kvsHistoryList = data || [];
    kvsHistoryList = kvsHistoryList.map((kvsHistory) => {
      return new KioskVersionSetHistory(kvsHistory);
    });
    dispatch({
      type: ActionTypes.ADD_KVS_HISTORY_LIST,
      kvsHistoryList: kvsHistoryList,
    });
    return kvsHistoryList;
  });
}

export function getQueueActionLog() {
  return (dispatch) => {
    Api.getQueueActionLog().then((queueActionData) => {
      dispatch({
        type: ActionTypes.ADD_QUEUE_ACTION_LOG,
        queueActionLog: queueActionData,
      });
    });
  };
}

export function createKVS(kvs) {
  return (dispatch) => {
    return Api.createKVS(kvs).then((data) => {
      let newKVS = new KioskVersionSet(data);
      dispatch({
        type: ActionTypes.ADD_KVS,
        kvs: newKVS,
      });
      _fetchKVSHistoryList(dispatch);
      return newKVS;
    });
  };
}

export function updateKVS(kvs) {
  return (dispatch) => {
    return Api.updateKVS(kvs).then((data) => {
      let newKVS = new KioskVersionSet(data);
      dispatch({
        type: ActionTypes.ADD_KVS,
        kvs: newKVS,
      });
      _fetchKVSHistoryList(dispatch);
      return newKVS;
    });
  };
}

export function deleteKVS(name, reason, updatedBy) {
  return (dispatch) => {
    return Api.deleteKVS(name, reason, updatedBy).then((data) => {
      dispatch({
        type: ActionTypes.DELETE_KVS,
        name: name,
      });
      _fetchKVSHistoryList(dispatch);
      return data;
    });
  };
}

export function getAppInfoList() {
  return (dispatch) => {
    return Api.getAppInfoList().then((data) => {
      let appInfoList = data || [];
      appInfoList = appInfoList.map((appInfo) => {
        return new AppInfo(appInfo);
      });
      dispatch({
        type: ActionTypes.ADD_APP_INFO_LIST,
        appInfoList: appInfoList,
      });
      return appInfoList;
    });
  };
}

export function checkAllAppInfoList() {
  return (dispatch) => {
    return Api.checkAllAppInfoList().then((data) => {
      let appInfoList = data || [];
      appInfoList = appInfoList.map((appInfo) => {
        return new AppInfo(appInfo);
      });
      dispatch({
        type: ActionTypes.ADD_APP_INFO_LIST,
        appInfoList: appInfoList,
      });
      return appInfoList;
    });
  };
}

export function checkAndCreateAppInfo(appInfo) {
  return _checkAppInfo(appInfo, true);
}

export function checkAndUpdateResult(appInfo = {}) {
  return _checkAppInfo(new AppInfo(appInfo), false);
}

function _checkAppInfo(appInfo, create = true) {
  return (dispatch) => {
    return Api.checkAppInfo(appInfo, create).then((data) => {
      let newAppInfo = new AppInfo(data);
      dispatch({
        type: ActionTypes.ADD_APP_INFO,
        appInfo: newAppInfo,
      });
      return newAppInfo;
    });
  };
}

export function updateAppInfo(appInfo) {
  return (dispatch) => {
    return Api.updateAppInfo(appInfo).then((data) => {
      let newAppInfo = new AppInfo(data);
      dispatch({
        type: ActionTypes.ADD_APP_INFO,
        appInfo: newAppInfo,
      });
      return newAppInfo;
    });
  };
}

export function deleteAppInfo(id) {
  return (dispatch) => {
    return Api.deleteAppInfo(id).then((data) => {
      dispatch({
        type: ActionTypes.DELETE_APP_INFO,
        appInfo: {
          id: id,
        },
      });
      return data;
    });
  };
}

export function getLogURLList() {
  return (dispatch) => {
    return Api.getLogURLList().then((data) => {
      let logURLList = data || [];
      logURLList = logURLList.map((logURL) => {
        return new LogURL(logURL);
      });
      dispatch({
        type: ActionTypes.ADD_LOG_URL_LIST,
        logURLList: logURLList,
      });
      return logURLList;
    });
  };
}

export function createLogURL(logURL) {
  return (dispatch) => {
    return Api.createLogURL(logURL).then((data) => {
      let newLogURL = new LogURL(data);
      dispatch({
        type: ActionTypes.ADD_LOG_URL,
        logURL: newLogURL,
      });
      return newLogURL;
    });
  };
}

export function updateLogURL(logURL) {
  return (dispatch) => {
    return Api.updateLogURL(logURL).then((data) => {
      let newLogURL = new LogURL(data);
      dispatch({
        type: ActionTypes.ADD_LOG_URL,
        logURL: newLogURL,
      });
      return newLogURL;
    });
  };
}

export function deleteLogURL(id) {
  return (dispatch) => {
    return Api.deleteLogURL(id).then((data) => {
      dispatch({
        type: ActionTypes.DELETE_LOG_URL,
        logURL: {
          id: id,
        },
      });
      return data;
    });
  };
}

export function selectedHostInfoId(hostInfoId) {
  return {
    type: ActionTypes.SELECT_HOSTINFO_ID,
    hostInfoId,
  };
}

export function selectedHostInfoIdList(hostInfoIdList) {
  return {
    type: ActionTypes.SELECT_HOSTINFO_ID_LIST,
    hostInfoIdList,
  };
}

export function unselectAllHostInfoIdList() {
  return {
    type: ActionTypes.UNSELECT_ALL_HOSTINFO_ID_LIST,
  };
}

export function unselectHostInfoId(hostInfoId) {
  return {
    type: ActionTypes.UNSELECT_HOSTINFO_ID,
    hostInfoId,
  };
}

export function setKVS(kvs) {
  return {
    type: ActionTypes.SET_KVS,
    kvs: kvs,
  };
}

function _updateHostInfoList(dispatch, getState, hostInfoList) {
  if (!_.isArray(hostInfoList)) {
    hostInfoList = [];
  }
  let state = getState();
  let kvsList = state.kvsList || [];

  hostInfoList.forEach((hostInfo) => {
    let h = new HostInfo({ ...hostInfo });
    h.calculateKvsNames(kvsList);
    dispatch({
      type: ActionTypes.ADD_HOST_INFO,
      hostInfo: h,
    });
    dispatch(selectedHostInfoId(hostInfo.id));
  });
  return hostInfoList;
}

function _reject(obj) {
  let msg =
    "This shouldn't happen. It could mean the kiosk name is not found " +
    'in sosdb or bug in dashweb code.';
  console.error(msg, obj);
  // this could happen because of the bug in handling selected kiosk
  return Promise.reject(() => {
    return new Error(msg);
  });
}

export function updateKioskTag(hostInfo, tag = '') {
  if (!hostInfo.sosdbKioskName) {
    return _reject(hostInfo);
  }

  return (dispatch, getState) => {
    return Api.updateSosdbKioskTag(hostInfo.sosdbKioskName, tag).then((data) => {
      // could be more than one hostInfo ties to the same kiosk name
      return _updateHostInfoList(dispatch, getState, data);
    });
  };
}

export function updateKioskDeploymentSet(hostInfo, deploymentSet = '') {
  if (!hostInfo.sosdbKioskName) {
    return _reject(hostInfo);
  }

  return (dispatch, getState) => {
    return Api.updateSosdbKioskDeploymentSet(hostInfo.sosdbKioskName, deploymentSet).then(
      (data) => {
        // could be more than one hostInfo ties to the same kiosk name
        return _updateHostInfoList(dispatch, getState, data);
      }
    );
  };
}

export function updatePatchDateAndTime(kioskNames, patchDate, patchTime) {
  if (kioskNames.length == 0) {
    return _reject(kioskNames);
  }

  return (dispatch, getState) => {
    return Api.updateSosdbPatchDateAndTime(kioskNames, patchDate, patchTime).then((data) => {
      // could be more than one hostInfo ties to the same kiosk name
      if (Object.keys(data).length === 0) {
        alert('Successfully updated patch date and time');
      } else {
        alert(data.msg);
      }
      return _updateHostInfoList(dispatch, getState, data);
    });
  };
}

export function updateKioskInstallUpdateTime(hostInfo, installUpdateTime = '') {
  if (!hostInfo.sosdbKioskName) {
    return _reject(hostInfo);
  }

  return (dispatch, getState) => {
    return Api.updateSosdbKioskInstallUpdateTime(hostInfo.sosdbKioskName, installUpdateTime).then(
      (data) => {
        // could be more than one hostInfo ties to the same kiosk name
        return _updateHostInfoList(dispatch, getState, data);
      }
    );
  };
}

export function getXpressTemplateList() {
  return (dispatch) => {
    Api.getXTemplateList().then((data) => {
      let templateList = data || [];
      dispatch({
        type: ActionTypes.ADD_XPRESS_TEMPLATE_LIST,
        payload: templateList,
      });
    });
  };
}

export function getSosdbG2ConvertHistorySwapList() {
  return (dispatch) => {
    return Api.getSosdbG2ConvertHistorySwapList().then((data) => {
      let g2ConvertHistoryList = data || [];
      g2ConvertHistoryList = g2ConvertHistoryList.map((cvtHistory) => {
        return new SosdbG2ConvertHistory(cvtHistory);
      });
      dispatch({
        type: ActionTypes.ADD_G2_CONVERT_HISTORY_LIST,
        g2ConvertHistoryList: g2ConvertHistoryList,
      });
      return g2ConvertHistoryList;
    });
  };
}

export function getSosdbG2ConvertHistoryCopyList() {
  return (dispatch) => {
    return Api.getSosdbG2ConvertHistoryCopyList().then((data) => {
      let g2ConvertHistoryList = data || [];
      g2ConvertHistoryList = g2ConvertHistoryList.map((cvtHistory) => {
        return new SosdbG2ConvertHistory(cvtHistory);
      });
      dispatch({
        type: ActionTypes.ADD_G2_CONVERT_HISTORY_LIST,
        g2ConvertHistoryList: g2ConvertHistoryList,
      });
      return g2ConvertHistoryList;
    });
  };
}

export function getOrg2OrgHistoryCopyList() {
  return (dispatch) => {
    return Api.getOrg2OrgHistoryCopyList().then((data) => {
      console.log(data);
      let org2OrgHistoryList = data || [];
      org2OrgHistoryList = org2OrgHistoryList.map((history) => {
        return new Org2OrgConvertHistory(history);
      });
      dispatch({
        type: ActionTypes.ADD_ORG_TO_ORG_HISTORY_LIST,
        org2OrgHistoryList: org2OrgHistoryList,
      });
      return org2OrgHistoryList;
    });
  };
}

export function getQueueActionData() {
  return (dispatch) => {
    Api.getQueueActionData().then((queueActionData) => {
      dispatch({
        type: ActionTypes.ADD_QUEUE_ACTION_DATA,
        queueActionData: queueActionData,
      });
    });
  };
}

export function updateLastAccessedKiosk(hostInfoId) {
  return {
    type: ActionTypes.UPDATE_LAST_ACCESSED_KIOSK,
    hostInfoId,
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions.js